import CustomSearchDropdown from 'components/common/CustomSearchDropdown/ver2';
import SizeBox from 'components/common/SizeBox';
import { REGISTER_STREET_TYPES } from 'constants';
import CustomAddressFinderDropdown from 'features/pii/components/FormPIIProfileResidentialAddress/components/CustomAddressFinderDropdown';
import CustomAddressPostcodeDropdown from 'features/pii/components/FormPIIProfileResidentialAddress/components/CustomAddressPostcodeDropdown';
import FormInputAddressFinderManualSwitch from 'features/pii/components/FormPIIProfileResidentialAddress/components/FormInputAddressFinderManualSwitch';
import FormInputValidation from 'features/pii/components/FormPIIProfileResidentialAddress/components/FormInputValidation';
import {
  PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_FIELD,
  PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME,
  RESET_PII_PROFILE_RESIDENTIAL_ADDRESS,
} from 'features/pii/const';
import useProfile from 'features/profile2.0/hooks/useProfile';
import withConfirmCancelFormEditModal from 'features/profileKYC/HOCs/withConfirmCancelFormEditModal';
import useProfileKYC from 'features/profileKYC/hooks/useProfileKYC';
import useProfileKYCStore from 'features/profileKYC/hooks/useProfileKYCStore';
import { address } from 'helpers';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import React, { useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';
import { textEllipsisFirstLineMixinObj } from 'styles';
import FormEditItemExpandable from '../FormEditItemExpandable';

const FormEditItemExpandableExt = withConfirmCancelFormEditModal(
  FormEditItemExpandable
);

const initialFormField = {
  ...RESET_PII_PROFILE_RESIDENTIAL_ADDRESS,
};

const INDEX = 1;

const FormEditResidentialAddress = ({
  ref,
  inputRef,
  currentEdit,
  setCurrentEdit,
  information,
  setInformation,
  validation,
  setValidation,
  checkFormInputValidation,
  isNextButtonDisabled,
}) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  const { getFormProfileKYCResidentialAddress, setFormProfileKYCInformation } =
    useProfileKYCStore();
  const formProfileKYCResidentialAddressStore =
    getFormProfileKYCResidentialAddress();

  const { checkResidentialAddressProfileFullAddressChange } = useProfileKYC();
  const { getProfileFullAddress } = useProfile();
  const profileFullAddress = getProfileFullAddress();
  const currentProfileAddressStreet =
    address.addressStreetSplitFromFullAddress(
      information[PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME]
    ) || '';
  const currentProfileAddressPostcode =
    address.addressPostcodeSplitFromFullAddress(
      information[PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME]
    )?.addressPostcode || '';
  const currentProfileFullAddress = `${currentProfileAddressStreet}${
    currentProfileAddressPostcode ? ', ' + currentProfileAddressPostcode : ''
  }`;
  const profileAddressStreetStore = address.addressStreetSplitFromFullAddress(
    formProfileKYCResidentialAddressStore[
      PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME
    ]
  );
  const profileAddressPostcodeStore =
    address.addressPostcodeSplitFromFullAddress(
      formProfileKYCResidentialAddressStore[
        PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME
      ]
    )?.addressPostcode;
  const profileFullAddressStore = `${profileAddressStreetStore}${
    profileAddressPostcodeStore ? ', ' + profileAddressPostcodeStore : ''
  }`;

  const isResidentialAddressProfileFullAddressInformationChange =
    checkResidentialAddressProfileFullAddressChange(
      currentProfileFullAddress,
      profileFullAddress
    );
  const isResidentialAddressProfileFullAddressStoreChange =
    checkResidentialAddressProfileFullAddressChange(
      currentProfileFullAddress,
      profileFullAddressStore
    );

  const isEnterAddressManual = Boolean(
    information[PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME]
  );

  useImperativeHandle(ref, () => ({}), []);

  const formEditItemExpandableRef = useRef();
  const { setExpand } = formEditItemExpandableRef?.current || {};

  const resetValidation = () => {
    const newValidation = {
      ...validation,
      ...initialFormField,
    };
    setValidation(newValidation);
  };

  const renderCustomAddressFinderDropdown = () => {
    if (isEnterAddressManual) return null;
    return (
      <>
        <CustomAddressFinderDropdown
          field={PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_FIELD}
          information={information}
          setInformation={setInformation}
          validation={validation}
          setValidation={setValidation}
        />
        <SizeBox height={30} />
      </>
    );
  };

  const renderFormEnterAddressManual = () => {
    if (!isEnterAddressManual) return null;
    return (
      <>
        <SizeBox height={isDesktop ? 40 : 16} />
        <FormEnterAddressManualStyled>
          <EnterAddressManualRow>
            <FormInputValidation
              field={PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_FIELD}
              information={information}
              setInformation={setInformation}
              validation={validation}
              setValidation={setValidation}
              checkFormInputValidation={checkFormInputValidation}
            />
            <FormInputValidation
              field={PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_FIELD}
              information={information}
              setInformation={setInformation}
              validation={validation}
              setValidation={setValidation}
              checkFormInputValidation={checkFormInputValidation}
            />
          </EnterAddressManualRow>
          <SizeBox height={16} />
          <EnterAddressManualRow>
            <FormInputValidation
              ref={inputRef}
              field={PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_FIELD}
              information={information}
              setInformation={setInformation}
              validation={validation}
              setValidation={setValidation}
              checkFormInputValidation={checkFormInputValidation}
            />
            <CustomSearchDropdown
              field={PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_FIELD}
              data={REGISTER_STREET_TYPES}
              keyFind="key"
              keyTranslate="value"
              noResultText="form_text_no_result"
              information={information}
              setInformation={setInformation}
              validation={validation}
              setValidation={setValidation}
              styles={{
                width: '100%',
                marginBottom: 0,
              }}
              toggleTextStyles={textEllipsisFirstLineMixinObj}
            />
          </EnterAddressManualRow>
          <SizeBox height={16} />
          <EnterAddressManualRow>
            <CustomAddressPostcodeDropdown
              field={PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_FIELD}
              information={information}
              setInformation={setInformation}
              validation={validation}
              setValidation={setValidation}
            />
          </EnterAddressManualRow>
          <SizeBox height={16} />
          <EnterAddressManualRow>
            <FormInputValidation
              field={PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_FIELD}
              information={information}
              setInformation={setInformation}
              validation={validation}
              setValidation={setValidation}
              checkFormInputValidation={checkFormInputValidation}
            />
            <FormInputValidation
              field={PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_FIELD}
              information={information}
              setInformation={setInformation}
              validation={validation}
              setValidation={setValidation}
              checkFormInputValidation={checkFormInputValidation}
            />
          </EnterAddressManualRow>
        </FormEnterAddressManualStyled>
        <SizeBox height={isDesktop ? 40 : 0} />
      </>
    );
  };

  const handleOnOpenFormEditItemExpandable = () => {
    console.log(
      `⭐ FormEditResidentialAddress 👉 handleOnOpenFormEditItemExpandable ➡️ CLICKED ↩`
    );
    resetValidation();
    setCurrentEdit(INDEX);
  };
  const handleOnCloseFormEditItemExpandable = () => {
    const newInformation = {
      ...formProfileKYCResidentialAddressStore,
    };
    console.log(
      `⭐ FormEditResidentialAddress 👉 handleOnCloseFormEditItemExpandable ➡️ newInformation ↩`,
      newInformation
    );
    setInformation(newInformation);
    resetValidation();
    setCurrentEdit(-1);
    setExpand(false);
  };
  const handleOnUpdateFormEditItemExpandable = () => {
    let newInformation = { ...information };
    let newValidation = { ...validation };

    console.log(
      `⭐ FormEditResidentialAddress 👉 handleOnUpdateFormEditItemExpandable ➡️ isNextButtonDisabled ↩`,
      isNextButtonDisabled
    );
    if (isNextButtonDisabled) {
      if (isEnterAddressManual) {
        if (newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME]) {
          newValidation = checkFormInputValidation(
            newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME],
            PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_FIELD,
            newInformation,
            newValidation
          );
        }
        newValidation = checkFormInputValidation(
          newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME],
          PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_FIELD,
          newInformation,
          newValidation
        );
        newValidation = checkFormInputValidation(
          newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME],
          PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_FIELD,
          newInformation,
          newValidation
        );
        newValidation = checkFormInputValidation(
          newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME],
          PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_FIELD,
          newInformation,
          newValidation
        );
        newValidation = checkFormInputValidation(
          PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME,
          PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_FIELD,
          newInformation,
          newValidation
        );
        newValidation = checkFormInputValidation(
          newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME],
          PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_FIELD,
          newInformation,
          newValidation
        );
        newValidation = checkFormInputValidation(
          newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME],
          PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_FIELD,
          newInformation,
          newValidation
        );
      } else {
        newValidation = checkFormInputValidation(
          newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME],
          PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_FIELD,
          newInformation,
          newValidation
        );
      }
      console.log(
        `⭐ FormEditResidentialAddress 👉 handleOnUpdateFormEditItemExpandable ➡️ newValidation ↩`,
        newValidation
      );
      setValidation(newValidation);
      return false;
    }
    newInformation = {
      ...newInformation,
      ...(isResidentialAddressProfileFullAddressInformationChange ? {} : {}),
      ...(isEnterAddressManual
        ? {
            [PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME]:
              address.addressCombine(
                newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_UNITNAME_NAME],
                newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NO_NAME],
                newInformation[
                  PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_NAME_NAME
                ],
                newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STREET_TYPE_NAME]
                  ?.key,
                newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_SUBURB_NAME],
                newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_STATE_NAME],
                newInformation[PII_PROFILE_RESIDENTIAL_ADDRESS_POST_CODE_NAME]
              ),
          }
        : {}),
    };
    console.log(
      `⭐ FormEditResidentialAddress 👉 handleOnUpdateFormEditItemExpandable ➡️ newInformation ↩`,
      newInformation
    );
    setInformation(newInformation);
    setFormProfileKYCInformation(newInformation);
    setCurrentEdit(-1);
    return true;
  };
  console.log('currentProfileFullAddress:::', currentProfileFullAddress);

  return (
    <FormEditItemExpandableExt
      ref={formEditItemExpandableRef}
      label={t('label_residential_address')}
      value={currentProfileFullAddress}
      note={t('')}
      onOpen={handleOnOpenFormEditItemExpandable}
      onUpdate={handleOnUpdateFormEditItemExpandable}
      isDisabled={currentEdit !== -1 && currentEdit !== INDEX}
      isChange={isResidentialAddressProfileFullAddressStoreChange}
      onCloseFormEditItemExpandable={handleOnCloseFormEditItemExpandable}
    >
      {renderCustomAddressFinderDropdown()}
      <FormInputAddressFinderManualSwitch
        field={PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_FIELD}
        information={information}
        setInformation={setInformation}
        setValidation={setValidation}
      />
      <SizeBox height={16} />
      {renderFormEnterAddressManual()}
    </FormEditItemExpandableExt>
  );
};

const FormEnterAddressManualStyled = styled.div``;
const EnterAddressManualRow = styled.div`
  display: flex;
  gap: 12px;
`;

export default FormEditResidentialAddress;
